import React, { useState } from "react";
import SubmitButton from "./StyledComponents/SubmitButton";
import { useTranslation } from "../i18n/TranslationProvider";

const PrivacyPage = ({
  onClick,
  style,
  fromPaymentpage,
  firstName,
  lastName,
  goback,
}) => {
  const { t } = useTranslation();

  // Array values are stored as indexed keys (…List.0, …List.1, …); rebuild the list
  const tList = (prefix) => {
    const items = [];
    for (let i = 0; ; i++) {
      const key = `${prefix}.${i}`;
      const value = t(key);
      if (value === key) break;
      items.push(value);
    }
    return items;
  };
  const [signed, setSigned] = useState(false);

  const Arrow = () => (
    <svg width="80" height="48" viewBox="0 0 80 48" style={{ marginRight: '12px' }}>
      {/* Single combined arrow shape: rectangle body + triangle head */}
      <path d="M2,14 L46,14 L46,2 L78,24 L46,46 L46,34 L2,34 Z" fill="#FFD700" stroke="black" strokeWidth="2.5" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <div style={style}>
      <h3>{t("privacyPolicy.privacyPolicy.title")}</h3>
      <p>{t("privacyPolicy.privacyPolicy.lastUpdated")}</p>
      <p>{t("privacyPolicy.privacyPolicy.welcome")}</p>
      <h4>{t("privacyPolicy.privacyPolicy.introductionTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.introductionText1")}</p>
      <p>{t("privacyPolicy.privacyPolicy.introductionText2")}</p>
      <p>
        <strong>{t("privacyPolicy.privacyPolicy.strongText")}</strong>
      </p>
      <p>{t("privacyPolicy.privacyPolicy.consentText")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.definitionsTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.definitionsText1")}</p>
      <p>{t("privacyPolicy.privacyPolicy.definitionsText2")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.grantOfLicenseTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.grantOfLicenseText1")}</p>
      <p>{t("privacyPolicy.privacyPolicy.grantOfLicenseText2")}</p>
      <p>{t("privacyPolicy.privacyPolicy.noticesHeading")}</p>
      <p>
        <strong>{t("privacyPolicy.privacyPolicy.noticesText")}</strong>
        {" " + t("privacyPolicy.privacyPolicy.noticesText2")}
      </p>
      <p>
        <strong>{t("privacyPolicy.privacyPolicy.grantOfLicenseText3Heading")}</strong>
        {t("privacyPolicy.privacyPolicy.grantOfLicenseText3")}
      </p>
      <p>
        <strong>{t("privacyPolicy.privacyPolicy.grantOfLicenseText4")}</strong>
      </p>
      <p>
        <strong>{t("privacyPolicy.privacyPolicy.grantOfLicenseText5")}</strong>
      </p>

      <h4>{t("privacyPolicy.privacyPolicy.feeAndPaymentTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.feeAndPaymentText1")}</p>
      <p>
        <strong>{t("privacyPolicy.privacyPolicy.feeAndPaymentStrong1")}</strong>
      </p>
      <p>{t("privacyPolicy.privacyPolicy.feeAndPaymentText2")}</p>
      <p>{t("privacyPolicy.privacyPolicy.feeAndPaymentText3")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.availabilityTitle")}</h4>
      <p>
        {t("privacyPolicy.privacyPolicy.availabilityText1")}{" "}
        <u>{t("privacyPolicy.privacyPolicy.availabilityUnderline1")}</u>{" "}
        {t("privacyPolicy.privacyPolicy.availabilityText2")}
        <u>{t("privacyPolicy.privacyPolicy.availabilityUnderline2")}</u>
        {t("privacyPolicy.privacyPolicy.availabilityText3")}
      </p>
      <p>
        {t("privacyPolicy.privacyPolicy.availabilityText4")}
        <u>{t("privacyPolicy.privacyPolicy.availabilityUnderline3")}</u>
        {t("privacyPolicy.privacyPolicy.availabilityText5")}
      </p>
      <p>
        {t("privacyPolicy.privacyPolicy.availabilityText6")}{" "}
        {t("privacyPolicy.privacyPolicy.availabilityStrong")}
      </p>

      <h4>{t("privacyPolicy.privacyPolicy.authorizedUsersTitle")}</h4>
      <p>
        {t("privacyPolicy.privacyPolicy.authorizedUsersText1")}{" "}
        <u>{t("privacyPolicy.privacyPolicy.authorizedUsersUnderline1")}</u>{" "}
        {t("privacyPolicy.privacyPolicy.authorizedUsersText2")}{" "}
        <u>{t("privacyPolicy.privacyPolicy.authorizedUsersUnderline2")}</u>{" "}
        {t("privacyPolicy.privacyPolicy.authorizedUsersText3")}
      </p>
      <p>{t("privacyPolicy.privacyPolicy.authorizedUsersText4")}</p>
      <p>
        {t("privacyPolicy.privacyPolicy.authorizedUsersText5")}{" "}
        {t("privacyPolicy.privacyPolicy.authorizedUsersStrong")}
      </p>

      <h4>{t("privacyPolicy.privacyPolicy.useOfProductTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.useofproduct61text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.useofproduct62text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.useofproduct63text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.useofproduct64text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.useofproduct65text")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.contentTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.content71text") + " " + t("privacyPolicy.privacyPolicy.content71strong")}</p>
      <p>{t("privacyPolicy.privacyPolicy.content72text")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.intellectualPropertyTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.intellectualproperty81text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.intellectualproperty82text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.intellectualproperty83text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.intellectualproperty84text")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.accessAndContentTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.accessandcontent91text")}</p>
      <ul>
        {tList("privacyPolicy.privacyPolicy.accessandcontent91list").map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <p>{t("privacyPolicy.privacyPolicy.accessandcontent92text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.accessandcontent93text")}</p>
      <ul>
        {tList("privacyPolicy.privacyPolicy.accessandcontent93list").map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <p>{t("privacyPolicy.privacyPolicy.accessandcontent94text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.accessandcontent95text")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.warrantyDisclaimerTitle")}</h4>
      <p>
        {t("privacyPolicy.privacyPolicy.warrantydisclaimer101text")}
      </p>
      <p>
        {t("privacyPolicy.privacyPolicy.warrantydisclaimer102text")}
      </p>

      <h4>{t("privacyPolicy.privacyPolicy.limitationOfLiabilityTitle")}</h4>
      <p>
        {t("privacyPolicy.privacyPolicy.limitationofliability111text")}
      </p>
      <p>
        {t("privacyPolicy.privacyPolicy.limitationofliability112text")}
      </p>


      <h4>{t("privacyPolicy.privacyPolicy.termAndTerminationTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.termandtermination121text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.termandtermination122text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.termandtermination123text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.termandtermination124text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.termandtermination125text")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.governingLawTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.governinglaw131text")}</p>
      <p>
        {t("privacyPolicy.privacyPolicy.governinglaw132text")}
      </p>
      <p>{t("privacyPolicy.privacyPolicy.governinglaw133text")}</p>

      <h4>{t("privacyPolicy.privacyPolicy.miscellaneousTitle")}</h4>
      <p>{t("privacyPolicy.privacyPolicy.miscellaneous141text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.miscellaneous142text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.miscellaneous143text")}</p>
      <p>{t("privacyPolicy.privacyPolicy.miscellaneous144text")}</p>

      <p>{t("privacyPolicy.privacyPolicy.miscellaneousCompanyAddress")}</p>
      <p>{t("privacyPolicy.privacyPolicy.miscellaneousUserAddress")}</p>

      <div style={{ border: '1px solid #000', padding: '10px', margin: '10px 0' }}>
        <h4>For Authorized User</h4>
        <p>
          By completing the information and clicking the square below, I, as an Authorized User, hereby agrees to these terms.
        </p>
        {!fromPaymentpage && <div style={{
          display: 'flex',
          alignItems: 'center',
        }}>
          {!signed && <Arrow />}
          <SubmitButton onClick={() => { setSigned(true) }} style={{ fontSize: '1.25rem' }}>Sign</SubmitButton>
          <div style={{
            borderBottom: '1px solid #000',
            marginBottom: '0px',
            paddingBottom: '5px',
            paddingLeft: '10px',
            width: '150px',
          }}>{firstName + " " + lastName}</div>
        </div>}
        {!fromPaymentpage && (firstName || lastName) && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {signed && <Arrow />}
            <SubmitButton
              onClick={onClick}
              disabled={!signed}
              greyout={!signed}
              style={{
                fontSize: '1.25rem',
                ...(signed && {
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  color: 'white',
                })
              }}
            >
              I agree to the terms and conditions
            </SubmitButton>
          </div>
        )}
        {!fromPaymentpage && !firstName && !lastName && <SubmitButton onClick={goback} style={{ fontSize: '1.25rem' }}>Go back to enter the name</SubmitButton>}
      </div>
    </div>
  );
};

export default PrivacyPage;